import { httpGet, httpPost, httpDelete, httpPut } from "./AbstractService";
import ENDPOINTS from "../data/endpoints.json";

export const getMeetingTypes = (school, jwt) => {
  return httpGet( jwt, `${ENDPOINTS[school.region].school}/meeting/type/all`);
};

export const getMeetingTopics = (school, jwt) => {
  return httpGet( jwt, `${ENDPOINTS[school.region].school}/meeting/topic/all`);
};

export const getSchoolMeetings = (school, jwt) => {
  return httpGet( jwt, `${ENDPOINTS[school.region].school}/meeting/school/all`);
}

export const getTeacherMeetings = (school, jwt, dateStart, dateEnd) => {
  return httpGet( jwt, `${ENDPOINTS[school.region].school}/meeting/teacher/date/${dateStart}/${dateEnd}`);
}

export const getStudentMeetings = (school, jwt, dateStart, dateEnd) => {
  return httpGet( jwt, `${ENDPOINTS[school.region].school}/meeting/student/date/${dateStart}/${dateEnd}`);
}

export const getSchoolMeeting = (school, jwt, eid) => {
  return httpGet( jwt, `${ENDPOINTS[school.region].school}/meeting/${eid}`);
}

export const deleteSchoolMeeting = (school, jwt, eid) => {
  return httpDelete( jwt, `${ENDPOINTS[school.region].school}/meeting/${eid}`);
}

export const saveMeeting = (
  school,
  jwt,
  eid,
  title,
  studentEids,
  date,
  startHour,
  startMinute,
  endHour,
  endMinute,
  meetingTypeEid,
  topicEids,
  teacherEids,
  description
) => {
  const values = {
    title,
    studentEids,
    date,
    startHour,
    startMinute,
    endHour,
    endMinute,
    meetingTypeEid,
    topicEids,
    teacherEids,
    description,
  };

  if (eid == null) {
    return httpPost( jwt, `${ENDPOINTS[school.region].school}/meeting`, values);
  } else {
    return httpPut( jwt, `${ENDPOINTS[school.region].school}/meeting/${eid}`, values);
  }
};

export const createMeetingType = (school, jwt, name) => {
  return httpPost( jwt, `${ENDPOINTS[school.region].school}/meeting-type`, {name});
}

export const updateMeetingType = (school, jwt, eid, name) => {
  return httpPut( jwt, `${ENDPOINTS[school.region].school}/meeting-type/${eid}`, {name});
}

export const deleteMeetingType = (school, jwt, eid) => {
  return httpDelete( jwt, `${ENDPOINTS[school.region].school}/meeting-type/${eid}`);
}

export const createMeetingTopic = (school, jwt, name) => {
  return httpPost( jwt, `${ENDPOINTS[school.region].school}/meeting-topic`, {name});
}

export const deleteMeetingTopic = (school, jwt, eid) => {
  return httpDelete( jwt, `${ENDPOINTS[school.region].school}/meeting-topic/${eid}`);
}

export const updateMeetingTopic = (school, jwt, eid, name) => {
  return httpPut( jwt, `${ENDPOINTS[school.region].school}/meeting-topic/${eid}`, {name});
}
